<template>
    <b-card>
        <b-row class="pb-1">
            <b-col sm="8">
                <form @submit="updateSearch">
                    <b-form-input v-model="filter" @input="deBounce" :disabled="loading" placeholder="Type to search"></b-form-input>
                </form>
            </b-col>
            <b-col sm="4">
                <vc-date-picker v-model="dateRange" :popover="datePickerProps" :attributes="todaysDot" is-range class="" :model-config="modelConfig">
                    <template v-slot="{ inputValue, inputEvents }">
                        <b-row class="no-gutters">
                            <b-col>
                                <div class="text-center form-control" v-on="loading ? null : inputEvents.start" :disabled="loading">
                                    {{ dateRange.start | date }}{{ dateRange.start ? '': 'mm-dd-yyyy' }} - {{ dateRange.end | date }}{{ dateRange.end ? '': 'mm-dd-yyyy' }}
                                </div>
                            </b-col>
                            <b-col cols="2">
                                <i :disabled="loading" v-on:click="loading ? null :clearDate()" style="top: 5px; font-size:36px" class="pointer fa-solid fa-window-close text-danger"></i>
                            </b-col>
                        </b-row>
                    </template>
                </vc-date-picker>
                <!--
                <DateRangePicker style="width:100%"
                        ref="dt-picker"
                        v-model="dateRange"
                        @update="updateDate"
                        :single-date-picker="'range'"
                >
                    <template v-slot:input="picker">
                        <div class="text-center" style="width:100%">
                            {{ dateRange.start | date }}{{ dateRange.start ? '': 'mm-dd-yyyy' }} - {{ dateRange.end | date }}{{ dateRange.end ? '': 'mm-dd-yyyy' }}
                        </div>
                    </template>
                </DateRangePicker> -->
            </b-col>
        </b-row>
        <b-table ref="paymentsResults" striped hover borderless
                 show-empty
                 responsive
                 selectable
                 select-mode="multi"
                 selected-variant="primary"
                 head-variant="dark"
                 thead-tr-class="font-xs"
                 tbody-tr-class="align-middle"
                 primary-key="id"
                 @row-selected="onRowSelected"
                 :busy.sync="loading"
                 :fields="getFields()"
                 :items="items"
                 :tbody-tr-class="rowVariant"
                 no-provider-sorting
                 no-provider-filtering>
            <template v-slot:table-busy>
                <LoadingSpinner :busy="loading"/>
            </template>

            <template v-slot:head(selected)="row">
                <b-button size="sm" variant="outline-secondary" class="p-0" :pressed.sync="allSelected">
                    <i class="fa-regular fa-check fa-fw"></i>
                </b-button>
            </template>

            <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                    <i class="fa-regular fa-check-square fa-fw"></i>
                </template>
                <template v-else>
                    <i class="fa-regular fa-square fa-fw"></i>
                </template>
            </template>

            <template v-slot:cell(created_at)="data">
                <div class="font-xs">{{ data.value | date }}</div>
                <div class="font-xs">{{ data.value | time }}</div>
            </template>

            <template v-slot:cell(processed_at)="data">
                <div class="font-xs">{{ data.value | date }}</div>
                <div class="font-xs">{{ data.value | time }}</div>
            </template>
            <template v-slot:cell(accepted_at)="data">
                <div class="font-xs">{{ data.value | date }}</div>
                <div class="font-xs">{{ data.value | time }}</div>
            </template>

            <template v-slot:cell(order_id)="data">
                <b-link :href="'/kit/view/'+ data.value">{{ data.value }}</b-link>
                <div class="font-xxs font-weight-bold">{{ data.item.order_status }}</div>
            </template>

            <template v-slot:cell(amount)="data">
                <div class="text-nowrap" :class="[data.item.payout_summary.total > 10000.00 ? 'text-success font-weight-bold' : '']"><span class="font-xs">$</span> {{ data.value | toFixed2 }}</div>
            </template>

            <template v-slot:cell(payout_summary)="data">
                <div class="text-center">
                    <div class="font-weight-bold font-lg" :class="data.value.payout_rate >= 90 ? 'bg-danger' : ''">{{
                        data.value.payout_rate }}%
                    </div>
                    <b-button :id="'payout_summary_' + data.index" variant="link" class="p-0 m-0 font-xxs" size="sm">
                        More Details <i class="fa-regular fa-caret-square-down fa-fw"></i>
                    </b-button>
                    <b-popover :target="'payout_summary_' + data.index" triggers="click blur" placement="bottom">
                        <table>
                            <tr>
                                <td>Metal:</td>
                                <td></td>
                                <td>${{ data.value.metal | toFixed2 }}</td>
                            </tr>
                            <tr class="border-bottom">
                                <td>Value Additions:</td>
                                <td></td>
                                <td>${{ data.value.numismatic | toFixed2 }}</td>
                            </tr>
                            <tr class="border-bottom-double">
                                <td>Total:</td>
                                <td></td>
                                <td>${{ data.value.total | toFixed2 }}</td>
                            </tr>

                            <tr>
                                <td>Base Offer:</td>
                                <td class="font-italic text-muted">{{ data.value.base_offer_rate }}%</td>
                                <td>${{ data.value.base_offer | toFixed2 }}</td>
                            </tr>
                            <tr>
                                <td>Negotiated:</td>
                                <td class="font-italic text-muted">{{ data.value.negotiated_rate }}%</td>
                                <td>${{ data.value.negotiated | toFixed2 }}</td>
                            </tr>
                            <tr class="border-bottom">
                                <td>Bonus:</td>
                                <td class="font-italic text-muted">{{ data.value.bonus_rate }}%</td>
                                <td>${{ data.value.bonus | toFixed2 }}</td>
                            </tr>

                            <tr class="border-bottom-double">
                                <td>Purchase Price:</td>
                                <td></td>
                                <td>${{ data.value.purchase_price | toFixed2 }}</td>
                            </tr>

                            <tr class="font-weight-bold">
                                <td>Payout %:</td>
                                <td></td>
                                <td>{{ data.value.payout_rate }}%</td>
                            </tr>
                        </table>
                    </b-popover>
                </div>
            </template>

            <template v-slot:cell(payment_method)="data">
                <div class="text-center">
                    <template v-if="data.value.method === 'company-check'">
                        <i class="fa-regular fa-money-check-alt fa-fw fa-lg"></i>
                        <div class="font-xxs">{{ data.item.address1 }}</div>
                        <div class="font-xxs">{{ data.item.address2 }}</div>
                        <div class="font-xxs">{{ data.item.city }}, {{ data.item.state }} {{ data.item.zip }}</div>
                    </template>
                    <template v-if="data.value.method === 'direct-deposit'">
                        <i class="fa-solid fa-university fa-fw fa-lg"></i>
                        <div class="font-xxs">Routing: {{ data.value.routing_number }}</div>
                        <div class="font-xxs">Account: {{ data.value.account_number }}</div>
                    </template>
                    <template v-if="data.value.method === 'paypal'">
                        <i class="fab fa-paypal fa-fw fa-lg"></i>
                        <div class="font-xxs">{{ data.value.paypal_email }}</div>
                    </template>
                </div>
            </template>

            <template v-slot:cell(payment_type)="data">
                <div class="font-xs">{{ data.value | titleCase }}</div>
                <div v-if="data.value === 'customer-payment' || data.value === 'reissue'">
                    <i class="fa-duotone fa-closed-captioning fa-fw" v-if="data.item.acceptance_type === 'system'" v-b-tooltip.hover title="Customer Convenience Accepted"></i>
                    <i class="fa-duotone fa-user-check fa-fw" v-else-if="data.item.acceptance_type === 'user'" v-b-tooltip.hover title="Customer Accepted"></i>
                    <i class="fa-duotone fa-user-headset fa-fw" v-else-if="data.item.acceptance_type === 'agent'" v-b-tooltip.hover title="Agent Accepted"></i>
                </div>
                <div>
                    <b-badge pill variant="info" v-if="data.item.memo" :id="'memo-popover-' + data.item.id">Memo</b-badge>
                    <b-popover :target="'memo-popover-' + data.item.id" triggers="hover focus" placement="left" custom-class="p-2">
                        <span v-html="data.item.memo"></span>
                    </b-popover>
                </div>
            </template>

            <template v-slot:cell(payments)="data">
                <div class="text-danger font-weight-bold" v-if="data.value > 1">{{ data.value }} <i class="fa-regular fa-exclamation-triangle fa-fw"></i></div>
                <div v-else>{{ data.value }}</div>
            </template>

            <template v-slot:cell(notes)="data">
                <NotesModule :variant="'secondary'" :order_id ="data.item.order_id" :customer_id="data.item.customer_id" user="user"></NotesModule>
            </template>

            <template v-slot:cell(regulatory_compliance)="data">
                <template v-if="data.value">
                    <div v-for="(item, index) in data.value" v-bind:key="index">
                        <div class="text-danger font-xxs text-uppercase font-weight-bold"><i
                                class="fa-solid fa-times-octagon"></i> {{ item
                            }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-center">
                        <i class="fa-solid fa-shield-check fa-lg fa-fw text-success"></i>
                    </div>
                </template>
            </template>

            <template v-slot:cell(flags)="data">
                <div class="text-center" :key="data.index">
                    <b-button  v-if="non_cleared_flags(data.value).length" :id="'flags_' + data.index" variant="link" class="p-0"><i
                            class="fa-regular fa-flag-checkered fa-lg fa-fw text-warning"></i>
                    </b-button>
                    <b-button  v-else :id="'flags_' + data.index" variant="link" class="p-0" @click="addFlag(data.item)"><i
                            class="fa-regular fa-flag-checkered fa-lg fa-fw text-success"></i>
                    </b-button>


                    <b-popover id="flag-popover" v-if="non_cleared_flags(data.value).length" :target="'flags_' + data.index" title="Flags" triggers="click blur" placement="bottom">
                        <template #title>
                            <b-form-row>
                                <b-col>Flags</b-col>
                                <b-col cols="8">
                                    <b-button @click="addFlag(data.item)"
                                              class="float-right"
                                              size="sm">
                                        <i class="fa-regular fa-plus"></i> Add Flag
                                    </b-button>
                                </b-col>
                            </b-form-row>

                        </template>
                        <b-list-group flush class="set-height">
                            <b-list-group-item href="#" class="flex-column align-items-start p-0" v-for="(flag, index) in non_cleared_flags(data.value)" :key="index">
                                <h5 class="mb-1 text-center" @click="editFlag(data.item, flag)">
                                    <b-badge v-b-tooltip.hover class="px-2" :variant="getVariant(flag.flag_type.config)" :title="flag.note" pill>{{ flag.flag_type.abbreviations }}</b-badge>
                                </h5>
                            </b-list-group-item>
                        </b-list-group>
                    </b-popover>
                </div>
            </template>

        </b-table>

        <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                :current-page="currentPage"
                aria-controls="fulfillment-results"
                align="center"
                size="sm"
        ></b-pagination>
    </b-card>
</template>

<script>
    import NotesModule from '../../components/NotesPopupFullfilment'
    import LoadingSpinner from '@/components/LoadingSpinner';
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import moment from 'moment';
    import {each, findLast, round} from 'lodash';

    export default {
        name: 'payments-list',
        components: {
            NotesModule,
            LoadingSpinner,
            DateRangePicker,
        },
        data() {
            return {
                loading: false,
                perPage: 30,
                currentPage: 1,
                totalRows: 0,
                filter: "",
                selected: [],
                allSelected: false,
                //date time picker
                dateRange: {
                    start: null,
                    end: null
                },
                targetOrder: null,
                targetPosition: null,
                items: [],
                datePickerProps: {
                    placement: 'bottom',
                },
                todaysDot: [
                    {
                        key: 'today',
                        dot: true,
                        content: 'blue',
                        dates: new Date(),
                    }
                ],
                modelConfig: {
                    start: {
                        timeAdjust: '00:00:00',
                    },
                    end: {
                        timeAdjust: '23:59:59',
                    },
                },
            };
        },
        created() {
            let startDate = new Date();
            startDate.setDate(startDate.getDate());
            let endDate = new Date();
            endDate.setDate(endDate.getDate());

            this.dateRange = {
                start: startDate,
                end: endDate
            };
            // Removed since the dateRange watcher calls this on load
            // this.getData(this.$refs.paymentsResults);
        },
        methods: {
            rowVariant(item) {
                if(item ? item.stop_workflow_active: false) {
                    return 'table-danger'
                }
            },
            updateDate(){
                this.getData(this.$refs.paymentsResults);
            },
            updateSearch(event) {
                if (event) {
                    event.preventDefault();
                }
                this.getData(this.$refs.paymentsResults);
            },

            deBounce: _.debounce(function() {
                if(this.filter.length > 4) {
                    this.updateSearch();
                } else {

                }
            }, 1500),
            clearDate(){
                let startDate = new Date();
                startDate.setDate(startDate.getDate());
                let endDate = new Date();
                endDate.setDate(endDate.getDate());

                this.dateRange = {
                    start: startDate,
                    end: endDate
                };
            },
            getFields(){
                var fields = [];
                switch(this.$route.params.status){
                    case 'pre-approved':
                    case 'approved':
                    case 'failed':
                        fields =
                            [
                                {key: 'selected', label: '', class: 'text-center'},
                                {key: 'created_at', label: 'Payment Created', sortable: true, class: 'text-center'},
                                {key: 'accepted_at', label: 'Offer Accepted', sortable: true, class: 'text-center'},
                                {key: 'order_id', sortable: true, class: 'text-center'},
                                {key: 'name',class: 'text-center'},
                                {key: 'amount', sortable: true, class: 'text-center'},
                                {key: 'payout_summary', class: 'text-center'},
                                {key: 'payment_method', label: 'Method', sortable: true, class: 'text-center'},
                                {key: 'payment_type', label: 'Payment Type', sortable: true, class: 'text-center'},
                                {key: 'payments', sortable: true, class: 'text-center'},
                                {key: 'notes', class: 'text-left'},
                                {key: 'regulatory_compliance', class: 'text-center'},
                                {key: 'flags', class: 'text-center'},
                            ]
                        break;
                    case 'processed':
                        fields =
                            [
                                {key: 'selected', label: '', class: 'text-center'},
                                {key: 'created_at', label: 'Payment Created', sortable: true, class: 'text-center'},
                                {key: 'processed_at', label: 'Payment Processed', sortable: true, class: 'text-center'},
                                {key: 'accepted_at', label: 'Offer Accepted', sortable: true, class: 'text-center'},
                                {key: 'order_id', sortable: true, class: 'text-center'},
                                {key: 'name',class: 'text-center'},
                                {key: 'amount', sortable: true, class: 'text-center'},
                                {key: 'payout_summary', class: 'text-center'},
                                {key: 'payment_method', label: 'Method', sortable: true, class: 'text-center'},
                                {key: 'payment_type', label: 'Payment Type', sortable: true, class: 'text-center'},
                                {key: 'payments', sortable: true, class: 'text-center'},
                                {key: 'notes', class: 'text-center'},
                                {key: 'flags', class: 'text-center'},
                            ]
                        break;
                }
                return fields;
            },
            non_cleared_flags: function(row){
                return _.filter(row,(e)=>{
                    return e.cleared_at == null;
                });
            },
            addFlag(payment){
                console.log(payment,'flag');
                this.targetOrder = payment.order_id;
                this.targetPosition = payment.flags.length;
                this.$store.commit('setAddFlag', payment.order_id);
            },
            editFlag(payment,flag){
                this.targetOrder = payment.order_id;
                this.targetPosition = _.findIndex(payment.flags, (e) => {return e.id == flag.id});
                this.$store.commit('setActiveFlag', flag);
            },
            updateFlag(flag){
                _.forEach(this.items, (e) =>{
                    if(e.order_id == this.targetOrder){
                        e.flags[this.targetPosition] = flag;
                    }
                });
                this.$forceUpdate();
            },
            getFilters(ctx){
                let url = 'filter[status]=' + this.$route.params.status;
                if (this.$route.params.method) {
                    url += '&filter[payment_method]=' + this.$route.params.method;
                }
                url += '&filter[search]=' + this.filter;
                if(this.dateRange && this.dateRange.start && this.dateRange.end){
                    switch(this.$route.params.status){
                        case 'processed':
                            url += '&filter[processed_start_date]=' + this.formatDate(this.dateRange.start);
                            url += '&filter[processed_end_date]=' + this.formatDate(this.dateRange.end);
                            break;
                        case 'pre-approved':
                        case 'approved':
                        case 'failed':
                            url += '&filter[created_start_date]=' + this.formatDate(this.dateRange.start);
                            url += '&filter[created_end_date]=' + this.formatDate(this.dateRange.end);
                            break;
                    }
                }
                url += '&current_page=' + this.currentPage;
                url += '&page[size]=' + this.perPage;
                if(ctx && ctx.sortBy){
                    url += '&sort=' + (ctx.sortDesc ? '-' : '' ) + ctx.sortBy;
                }
                else{
                    switch(this.$route.params.status){
                        case 'pre-approved':
                        case 'approved':
                            url += '&sort=' + 'created_at';
                            break;
                        case 'processed':
                        case 'failed':
                            url += '&sort=' + '-created_at';
                            break;
                    }
                }
                return url;
            },
            getReport(callback = function(){}){
                let url = '/payments/generateReport?' + this.getFilters(this.$refs.paymentsResults);
                this.$http.get(url, {
                    responseType: 'blob',
                }).then((response) => {
                    this.$http.downloadFile(response.data, 'payment_report'+Date.now()+'.csv');
                }).finally(()=>{
                    callback(); //for ui to update.
                });
            },
            getData(ctx) {
                this.loading = true;
                console.log(ctx);
                this.$emit('working', true);
                let url = '/payments?include=order,order.currentOffer,order.initialOffer,order.notes,order.flags,order.payments&' + this.getFilters(ctx);
                let promise = this.$http.get(url);

                promise.then(response => {
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                    this.totalRows = response.data.total;

                    let items = [];
                    each(response.data.data, payment => {
                        let currentOffer = payment.order.currentOffer;
                        let initialOffer = payment.order.initialOffer;
                        let manualPayment = false;
                        let payoutSummary = {
                            metal: currentOffer ? currentOffer.metal_value : 0,
                            numismatic: currentOffer ? currentOffer.numismatic_value : 0,
                            total: currentOffer ? currentOffer.total_value : 0,
                            base_offer: initialOffer ? initialOffer.total_offer : 0,
                            base_offer_rate: initialOffer ? initialOffer.base_offer_rate : 0,
                            negotiated: payment.order.negotiated_amount ,
                            negotiated_rate: payment.order.negotiated_rate,
                            bonus: currentOffer ? currentOffer.bonus_amount : 0,
                            bonus_rate: currentOffer ? currentOffer.bonus_rate: 0,
                            purchase_price: currentOffer ? currentOffer.payout_amount : 0,
                            payout_rate: currentOffer ? currentOffer.payout_rate : 0,
                        };
                        if (payment.created_by !== null && (payment.payment_type === 'customer-payment' || payment.payment_type === 'reimbursement' || payment.payment_type === 'claim')) {
                            manualPayment = true;
                        }
                        let previousAutoPayment = findLast(payment.order.payments, { 'created_by': null, 'payment_type': 'customer-payment' });
                        console.log(previousAutoPayment);
                        if (previousAutoPayment && manualPayment) {
                            let negotiated = parseFloat(payment.order.negotiated_amount) + parseFloat(payment.amount);
                            let negotiated_rate = round(((parseFloat(payment.order.negotiated_amount) + parseFloat(payment.amount)) / parseFloat(currentOffer.total_value)) * 100, 2);
                            let purchase_price = parseFloat(currentOffer.payout_amount) + parseFloat(payment.amount);
                            let payout_rate = round(((parseFloat(currentOffer.total_offer) + parseFloat(payment.amount) + parseFloat(currentOffer.bonus_amount)) / parseFloat(currentOffer.total_value)) * 100, 2);
                            payoutSummary = {
                                    metal: currentOffer ? currentOffer.metal_value : 0,
                                    numismatic: currentOffer ? currentOffer.numismatic_value : 0,
                                    total: currentOffer ? currentOffer.total_value : 0,
                                    base_offer: initialOffer ? initialOffer.total_offer : 0,
                                    base_offer_rate: initialOffer ? initialOffer.base_offer_rate : 0,
                                    negotiated: negotiated ,
                                    negotiated_rate: negotiated_rate,
                                    bonus: currentOffer ? currentOffer.bonus_amount : 0,
                                    bonus_rate: currentOffer ? currentOffer.bonus_rate: 0,
                                    purchase_price: purchase_price ? purchase_price : 0,
                                    payout_rate: payout_rate ? payout_rate : 0,
                                };
                        }
                        items.push({
                            id: payment.id,
                            processed_at: payment.processed_at,
                            created_at: payment.created_at,
                            accepted_at: currentOffer ? currentOffer.decided_at : null,
                            order_id: payment.order.id,
                            order_status: payment.order.status,
                            customer_id: payment.order.customer.id,
                            name: payment.order.customer.first_name + ' ' + payment.order.customer.last_name,
                            address1: payment.order.customer.address.address1,
                            address2: payment.order.customer.address.address2,
                            city: payment.order.customer.address.city,
                            state: payment.order.customer.address.state,
                            zip: payment.order.customer.address.zip,
                            amount: payment.amount,
                            payout_summary: payoutSummary,
                            payment_method: {
                                method: payment.payment_method,
                                routing_number: payment.bank_routing,
                                account_number: payment.bank_account,
                                paypal_email: payment.paypal_email,
                            },
                            payment_type: payment.payment_type,
                            acceptance_type: payment.order.accept_method,
                            memo: payment.memo,
                            payments: payment.order.payments_count,
                            notes: payment.order.notes || null,
                            regulatory_compliance: null,
                            flags: payment.order.flags || null,
                            stop_workflow_active: payment.order.customer.stop_workflow_active,
                        });
                    });
                    this.loading = false;
                    this.$emit('working', false);
                    this.$nextTick(()=> {
                        this.currentPage = response.data.current_page;
                        this.items = items || [];
                        this.$refs.paymentsResults.refresh();
                    });
                }).catch((err) =>
                {
                    console.log('error',err);
                    return [];
                });
            },
            onRowSelected(items) {
                this.selected = items;
                this.$emit('no-selection', items.length === 0);
                if (items.length === 0) {
                    this.allSelected = false;
                } else if (items.length === this.$refs.paymentsResults.$data.localItems.length) {
                    this.allSelected = true;
                }
            },
            selectAllRows() {
                this.$refs.paymentsResults.selectAllRows();
            },
            clearSelected() {
                this.$refs.paymentsResults.clearSelected();
            },
            approveSelected() {
                console.log(this.selected);
                let locked_ids = this.selected.filter(payment => payment.stop_workflow_active).map(payment => payment.order_id);
                if (locked_ids.length  > 0) {
                    let message = "The following orders have a stop workflow and will not be Approved, " + locked_ids.join(", ") + ', would you like to Approve the other orders?'
                    this.$bvModal.msgBoxConfirm(message, {
                        title: 'Issue with Approving Offers!',
                        size: 'md',
                        okTitle: 'Yes',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        cancelVariant: 'secondary',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    }).then((value)=>{if(value){this.approveSelcetedContinue();}});
                } else {
                    this.approveSelcetedContinue();
                }
            },
            approveSelcetedContinue() {
                this.$emit('working', true);
                let payments = this.selected.map(payment => payment.id);
                this.$http.post('/payments/approve', {
                    payments: payments
                }).then(() => {
                    this.$refs.paymentsResults.refresh();
                    this.$emit('working', false);
                    this.getData(this.$refs.paymentsResults);
                });
            },
            getVariant(config) {
                if(config) {
                    let decodedConfig = JSON.parse(config);
                    return decodedConfig.variant ? decodedConfig.variant : 'secondary';
                }
                return 'secondary';
            },
            processSelected() {
                let locked_ids = this.selected.filter(payment => payment.stop_workflow_active).map(payment => payment.order_id);
                if (locked_ids.length  > 0) {
                    let message = "the following orders have a stop workflow and will not be processed, " + locked_ids.join(", ") + ', would you like to Process the other orders?'
                    this.$bvModal.msgBoxConfirm(message, {
                        title: 'Issue with processing offers!',
                        size: 'md',
                        okTitle: 'Yes',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        cancelVariant: 'secondary',
                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                        footerClass: 'p-2 border-top-0',
                    }).then((value)=>{if(value){this.processSelectedContinue();}});
                } else {
                    this.processSelectedContinue();
                }
            },
            processSelectedContinue() {
                this.$emit('working', true);
                let payments = this.selected.map(payment => payment.id);
                this.$http.post('/payments/process', {
                    payments: payments
                }).then(() => {
                    this.$refs.paymentsResults.refresh();
                    this.$emit('working', false);
                    this.getData(this.$refs.paymentsResults);
                });
            },
            voidSelected() {
                let order_id = this.selected[0].order_id;
                this.$bvModal.msgBoxConfirm('Are you sure you want to void the selected payment for order ' + order_id + '?', {
                    title: 'Confirm Void Payment',
                    size: 'md',
                    okTitle: 'Yes',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    cancelVariant: 'secondary',
                    headerClass: 'p-2 border-bottom-0 text-center d-block',
                    footerClass: 'p-2 border-top-0',
                }).then((value) => {
                    if (value) {
                        this.voidSelectedContinue();
                    }
                });
            },
            voidSelectedContinue() {
                this.$emit('working', true);
                let payments = this.selected.map(payment => payment.id);
                this.$http.post('/payments/void', {
                    payments: payments
                }).then(() => {
                    this.$refs.paymentsResults.refresh();
                    this.$emit('working', false);
                    this.getData(this.$refs.paymentsResults);
                });
            },
            clearSelectedItems() {
                this.$emit('working', true);
                let payments = this.selected.map(payment => payment.id);
                this.$http.post('/payments/clear', {
                    payments: payments
                }).then(() => {
                    this.$refs.paymentsResults.refresh();
                    this.$emit('working', false);
                    this.getData(this.$refs.paymentsResults);
                });
            },
            formatDate(date_str){
                if (date_str) {
                    return moment(String(date_str)).format('MM/DD/YYYY');
                }
                return date_str;
            },
            failSelected() {
                this.$emit('working', true);

                //fail payments of non check
                let paymentsFailed = this.selected.filter((payment)=>{return payment.payment_method.method != 'company-check'}).map(payment => payment.id);
                let paymentsVoided = this.selected.filter((payment)=>{return payment.payment_method.method == 'company-check'}).map(payment => payment.id);

                let runVoid = () => {
                    //void payments of check
                    paymentsVoided = this.selected.filter((payment)=>{return payment.payment_method.method == 'company-check'}).map(payment => payment.id);
                    if(paymentsVoided.length > 0) {
                        this.$http.post('/payments/void', {
                            payments: paymentsVoided
                        }).then(() => {
                            this.$refs.paymentsResults.refresh();
                            this.$emit('working', false);
                            this.getData(this.$refs.paymentsResults);
                        });
                    }
                };
                //fixme make this one controller call.
                if(paymentsFailed.length > 0) {
                    this.$http.post('/payments/fail', {
                        payments: paymentsFailed
                    }).then(() => {
                        if (paymentsVoided.length > 0) {
                            runVoid();
                        } else {
                            this.$refs.paymentsResults.refresh();
                            this.$emit('working', false);
                            this.getData(this.$refs.paymentsResults);
                        }
                    });
                }
                else if (paymentsVoided.length > 0) {
                    runVoid();
                }
            },
            canVoidOnTypes: function(){
                return this.selected.filter((e)=>e.payment_method.method != 'company-check').length != 0;
            },
            selectedContainsVoidOnly(){
                return this.selected.filter((e)=>e.payment_method.method == 'company-check').length != 0;
            },
            selectContainsFailOnly(){
                return this.selected.filter((e)=>e.payment_method.method != 'company-check').length != 0;
            },
        },
        computed: {
            disableActions: function () {
                return this.selected.length <= 0;
            },
            disableVoidActions: function () {
                return this.selected.length != 1;
            },
            _isFlagUpdated () {
                return this.$store.getters.updatedFlag;
            },
        },
        watch: {
            $route() {
                this.currentPage = 1;
                this.$refs.paymentsResults.refresh();
            },
            allSelected: function (val) {
                if (val === true) {
                    this.selectAllRows();
                } else {
                    this.clearSelected();
                }
            },
            currentPage: function(val, oldVal) {
                if(val !== oldVal) {
                    this.getData(this.$refs.paymentsResults);
                }
            },
            _isFlagUpdated: {
                immediate: true,
                deep: true,
                handler(flag) {
                    if(this.items && this.items.length > 0) {
                        this.updateFlag(flag);
                    }
                }
            },
            dateRange: function(val){
                this.updateDate();
            },
            disableVoidActions: function (val) {
                this.$emit('disableVoidActions', val);
            },
        }
    };
</script>

<style scoped>
    .border-bottom-double {
        border-bottom-style: double;
        border-bottom-width: 3px;
    }
</style>
<style>
    #flag-popover {
        min-width: 180px!important;
    }
.set-height {
    padding: 0;
    margin:0;
    height: 200px !important;
    overflow: scroll !important;
}
.fixspan span {
    display: block;
}
</style>
